import { requestFromToggl } from "./requestFromToggl";

export function updateTagsOnTimeEntires(
  timeEntries,
  tags,
  successCb,
  failCb,
  tagAction = "add"
) {
  let timeEntryIdsSeperatedByComma = [];
  timeEntries.forEach((timeEntry) => {
    timeEntryIdsSeperatedByComma.push(timeEntry.time_entries[0].id);
  });

  timeEntryIdsSeperatedByComma = timeEntryIdsSeperatedByComma.join(",");

  console.log(timeEntryIdsSeperatedByComma);
  //   return;

  const url = `https://api.track.toggl.com/api/v8/time_entries/${timeEntryIdsSeperatedByComma}`;
  const method = "PUT";
  const body = {
    time_entry: { tags: tags, tag_action: tagAction },
  };

  requestFromToggl(url, method, body, successCb, failCb);
}
